<nz-select nzBorderless nzSelectOnTab
    [ngModel]="value"
    [nzDisabled]="disabled"
    (ngModelChange)="onTemplateChange($event)"
    [nzTokenSeparators]="[' ', ';', ',']"
    [nzPlaceHolder]="'field.mail-template' | translate">
    <nz-option *ngFor="let template of templates$ | async"
        [nzValue]="template"
        [nzLabel]="template.name || ('template-use-case.' + template.useCase | translate)">
    </nz-option>
</nz-select>